/**
 * TOP NEW ARRIVALS: テキストと商品カードのスクロール連動フェードアップ
 */
(function () {
  const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
  const REVEAL_SELECTOR = '[data-new-arrivals-reveal]';
  const VISIBLE_CLASS = 'is-visible';

  function debugLog(type, payload) {
    if (!window.EmissionScrollDebug) {
      return;
    }

    window.EmissionScrollDebug.log('new-arrivals:' + type, payload);
  }

  function getRoundedRect(element) {
    const rect = element.getBoundingClientRect();

    return {
      top: Math.round(rect.top),
      bottom: Math.round(rect.bottom),
      height: Math.round(rect.height),
    };
  }

  /**
   * 1セクション分のカード表示アニメーションを初期化する
   * @param {HTMLElement} sectionRoot
   */
  function initTopNewArrivalsSection(sectionRoot) {
    const prefersReducedMotion = window.matchMedia(REDUCED_MOTION_QUERY).matches;
    const revealElements = sectionRoot.querySelectorAll(REVEAL_SELECTOR);
    const cardImages = Array.from(sectionRoot.querySelectorAll('.new-arrivals__card-image'));
    let lastScrollY = window.scrollY;
    let isScrollingUp = false;

    if (sectionRoot._newArrivalsRevealCleanup) {
      sectionRoot._newArrivalsRevealCleanup();
      delete sectionRoot._newArrivalsRevealCleanup;
    }

    debugLog('init', {
      rect: getRoundedRect(sectionRoot),
      revealCount: revealElements.length,
      cardImageCount: cardImages.length,
      loadedImages: cardImages.filter((image) => image.complete && image.naturalWidth > 0).length,
      prefersReducedMotion: prefersReducedMotion,
    });

    cardImages.forEach((image, index) => {
      const logImageState = (eventType) => {
        debugLog('image:' + eventType, {
          index: index + 1,
          complete: image.complete,
          naturalWidth: image.naturalWidth || 0,
          currentSrc: image.currentSrc || image.src || '',
          rect: getRoundedRect(image),
        });
      };

      if (image.complete) {
        logImageState('complete-at-init');
      } else {
        image.addEventListener('load', () => logImageState('load'), { once: true });
        image.addEventListener('error', () => logImageState('error'), { once: true });
      }
    });

    if (revealElements.length === 0) {
      return;
    }

    if (prefersReducedMotion) {
      revealElements.forEach((element) => {
        element.classList.add(VISIBLE_CLASS);
      });
      return;
    }

    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          // 要素の上端がルート（ビューポート）の上端より上にある場合、
          // 上方向スクロールでビューポートの上から入ってきた要素と判定する。
          // 下からスクロールして来た際に未表示カードが複数同時にアニメーション開始すると
          // 描画負荷が集中してスクロールが固まることがある。
          // 上方向スクロール時は transition を一時的に無効化して即時表示し、負荷の集中を防ぐ。
          const elementRect = entry.boundingClientRect;
          const rootRect = entry.rootBounds;
          const enteredFromAbove =
            isScrollingUp || (rootRect !== null && elementRect.top < rootRect.top);

          if (enteredFromAbove) {
            entry.target.style.transition = 'none';
          }

          entry.target.classList.add(VISIBLE_CLASS);
          revealObserver.unobserve(entry.target);
          debugLog('reveal', {
            enteredFromAbove: enteredFromAbove,
            isScrollingUp: isScrollingUp,
            targetClass: entry.target.className,
            rect: getRoundedRect(entry.target),
          });

          if (enteredFromAbove) {
            // 次フレームで transition: none を解除する。
            // この時点で要素は is-visible 状態なので、解除してもアニメーションは発生しない。
            requestAnimationFrame(() => {
              entry.target.style.removeProperty('transition');
            });
          }
        });
      },
      {
        root: null,
        threshold: 0.12,
        // 参考サイトの ScrollMagic offset: 200 に近づけ、画面下端付近で早く出しすぎない。
        rootMargin: '0px 0px -200px 0px',
      }
    );

    revealElements.forEach((element) => {
      revealObserver.observe(element);
    });

    const updateScrollDirection = () => {
      const currentScrollY = window.scrollY;
      isScrollingUp = currentScrollY < lastScrollY;
      lastScrollY = currentScrollY;
    };

    window.addEventListener('scroll', updateScrollDirection, { passive: true });
    sectionRoot._newArrivalsRevealCleanup = () => {
      window.removeEventListener('scroll', updateScrollDirection);
      revealObserver.disconnect();
    };

    if (window.IntersectionObserver) {
      let lastRatioBucket = null;
      const sectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const ratioBucket = Math.round(entry.intersectionRatio * 4) / 4;

            if (ratioBucket === lastRatioBucket) {
              return;
            }

            lastRatioBucket = ratioBucket;
            debugLog('section-visibility', {
              ratio: Math.round(entry.intersectionRatio * 100) / 100,
              ratioBucket: ratioBucket,
              rect: getRoundedRect(sectionRoot),
            });
          });
        },
        {
          threshold: [0, 0.25, 0.5, 0.75, 1],
        }
      );

      sectionObserver.observe(sectionRoot);

      const previousCleanup = sectionRoot._newArrivalsRevealCleanup;
      sectionRoot._newArrivalsRevealCleanup = () => {
        previousCleanup();
        sectionObserver.disconnect();
      };
    }
  }

  function initAll() {
    document.querySelectorAll('[data-top-new-arrivals-section]').forEach(initTopNewArrivalsSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const sectionRoot = event.target.querySelector('[data-top-new-arrivals-section]');

    if (sectionRoot) {
      initTopNewArrivalsSection(sectionRoot);
    }
  });
})();
